import { render } from "./verify-login.vue?vue&type=template&id=e94610bc&scoped=true"
import script from "./verify-login.vue?vue&type=script&lang=js"
export * from "./verify-login.vue?vue&type=script&lang=js"

import "./verify-login.vue?vue&type=style&index=0&id=e94610bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\admin-tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e94610bc"]])

export default __exports__